module.exports = __webpack_public_path__ + "static/media/result_decoration.25bb97b9.png";